import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined, ExclamationOutlined } from "@ant-design/icons";

const NotificationContainer = observer(() => {
  const { notificationStore } = useStore();

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircleOutlined />;
      case "error":
        return <CloseCircleOutlined />;
      case "warning":
        return <ExclamationOutlined />;
      case "info":
        return <InfoCircleOutlined />;
      default:
        return null;
    }
  };

  const getDefaultTitle = (type) => {
    switch (type) {
      case "success":
        return "Approved";
      case "error":
        return "Error";
      case "warning":
        return "Warning";
      case "info":
        return "Information";
      default:
        return "";
    }
  };

  const handleButtonClick = (notification) => {
    if (notification.button && notification.button.onClick) {
      notification.button.onClick();
      notificationStore.closeNotification(notification.id);
    }
  };

  return (
    <div className="notification-container">
      {notificationStore.notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification notification-${notification.type} ${notification.visible ? "notification-enter" : "notification-exit"}`}
        >
          <div className="notification-header-with-close">
            <div className="notification-content">
              <div className="notification-header">
                <span className="notification-icon">{getIcon(notification.type)}</span>
                <h3 className="notification-title">{notification.title || getDefaultTitle(notification.type)}</h3>
              </div>
              <p className="notification-message">{notification.message}</p>
            </div>
          </div>

          {notification.button && (
            <div className="notification-footer">
              <button className="notification-action-button" onClick={() => handleButtonClick(notification)}>
                {notification.button.text}
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
});

export default NotificationContainer;
